import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=5d86042c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=5d86042c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d86042c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d86042c')) {
      api.createRecord('5d86042c', component.options)
    } else {
      api.reload('5d86042c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=5d86042c&scoped=true&", function () {
      api.rerender('5d86042c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKaCbPHhAIZY/JS/comp/GuestBox.vue"
export default component.exports